import './product-info-bar.scss';

class ProductInfoBar {
    constructor (element) {
        this.$container = element;
        this.$$tabs = this.$container.querySelectorAll('[role="tab"]');
    }

    init () {
        if (this.$container.dataset.initialized) {
            return;
        }
        this.$container.dataset.initialized = 'true';

        this.$$tabs.forEach(($tab, index) => {
            $tab.addEventListener('click', (e) => {
                e.preventDefault();
                this.setActiveTab($tab);
            });

            $tab.addEventListener('keydown', (e) => {
                this.onKeyDown(e, index);
            });
        });

        // Initialize first tab as active if none is selected
        const $selectedTab = this.$container.querySelector('[role="tab"][aria-selected="true"]') || this.$$tabs[0];
        if ($selectedTab) {
            this.setActiveTab($selectedTab);
        }
    }

    setActiveTab ($activeTab, shouldFocus = false) {
        const savedScrollY = window.scrollY;
        const activePanelId = $activeTab.getAttribute('aria-controls');

        this.$$tabs.forEach(($tab) => {
            const isSelected = $tab === $activeTab;
            $tab.setAttribute('aria-selected', isSelected);
            $tab.setAttribute('tabindex', isSelected ? '0' : '-1');

            if (isSelected && shouldFocus) {
                $tab.focus();
            }

            // Get the panel controlled by this tab
            const panelId = $tab.getAttribute('aria-controls');
            const $panel = document.getElementById(panelId);

            if ($panel) {
                if (panelId === activePanelId) {
                    $panel.removeAttribute('hidden');
                    // Force a reflow to restart animation if needed
                    const forceReflow = $panel.offsetWidth;

                    if (forceReflow) {
                        $panel.classList.add('is--active');

                        // Update any nested image-content-switcher modules
                        const $$nestedSwitchers = $panel.querySelectorAll('[data-imagecontentswitcher="root"]');
                        $$nestedSwitchers.forEach(($switcher) => {
                            if ($switcher.imageContentSwitcherAPI && typeof $switcher.imageContentSwitcherAPI.updateAllSliders === 'function') {
                                $switcher.imageContentSwitcherAPI.updateAllSliders();
                            }
                        });

                        // Update any nested model-finder sliders
                        const $$nestedModelFinders = $panel.querySelectorAll('[data-model-finder="slider"]');
                        $$nestedModelFinders.forEach(($modelFinder) => {
                            if ($modelFinder.modelFinderSliderAPI && typeof $modelFinder.modelFinderSliderAPI.update === 'function') {
                                $modelFinder.modelFinderSliderAPI.update();
                            }
                            if ($modelFinder.modelFinderSliderAPI && typeof $modelFinder.modelFinderSliderAPI.setEqualHeight === 'function') {
                                $modelFinder.modelFinderSliderAPI.setEqualHeight();
                            }
                        });
                    }
                } else {
                    $panel.setAttribute('hidden', '');
                    $panel.classList.remove('is--active');
                }
            }
        });

        requestAnimationFrame(() => {
            const $footer = document.querySelector('[data-footer]');
            const footerHeight = $footer ? $footer.offsetHeight : 0;
            const maxScrollY = document.documentElement.scrollHeight - window.innerHeight - footerHeight;

            if (savedScrollY > maxScrollY) {
                const $productStage = document.querySelector('.product-stage');
                const $scrollTarget = $productStage || this.$container;
                const rect = $scrollTarget.getBoundingClientRect();
                const elementBottom = window.scrollY + rect.top + rect.height;
                window.scrollTo({ top: elementBottom - window.innerHeight / 2, behavior: 'instant' });
            } else {
                window.scrollTo({ top: savedScrollY, behavior: 'instant' });
            }
        });
    }

    onKeyDown (e, index) {
        const { key } = e;
        let $targetTab = null;

        switch (key) {
        case 'ArrowLeft':
        case 'ArrowUp':
            $targetTab = this.$$tabs[index - 1] || this.$$tabs[this.$$tabs.length - 1];
            break;
        case 'ArrowRight':
        case 'ArrowDown':
            $targetTab = this.$$tabs[index + 1] || this.$$tabs[0];
            break;
        case 'Home':
            $targetTab = this.$$tabs[0];
            break;
        case 'End':
            $targetTab = this.$$tabs[this.$$tabs.length - 1];
            break;
        default:
            return;
        }

        if ($targetTab) {
            e.preventDefault();
            this.setActiveTab($targetTab, true);
        }
    }
}

export { ProductInfoBar };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context || document;

    if ($context) {
        const $$bars = $context instanceof HTMLElement && $context.classList.contains('product-info-bar')
            ? [$context]
            : $context.querySelectorAll('.product-info-bar');

        if ($$bars.length > 0) {
            for (let i = 0; i < $$bars.length; i++) {
                const productInfoBar = new ProductInfoBar($$bars[i]);
                productInfoBar.init();
            }
        }
    }
});
